import { formatPrice } from '../../utils/timedPlayConfig';
import {
  calcPerpetualRoi,
  calcPerpetualUnrealizedPnl,
  formatStakingLabel,
  parsePerpetualPlayConfig,
} from '../../utils/perpetualPlayConfig';

export default function PerpetualPositionCard({
  order,
  product,
  currentPrice,
  balance,
  closing = false,
  onClosePosition,
  onEditTpSl,
}) {
  if (!order) {
    return null;
  }

  const playConfig = parsePerpetualPlayConfig(product?.playConfig);
  const isLong = order.orderType === 'LONG';
  const pairLabel = product?.name || `${order.marketSymbolCode || ''}/USDT 永續`;
  const unrealizedPnl = calcPerpetualUnrealizedPnl(
    order.orderType,
    order.orderPrice,
    currentPrice,
    order.betAmount,
    order.contractMultiple
  );
  const roi = calcPerpetualRoi(unrealizedPnl, order.margin);
  const pnlClass = unrealizedPnl >= 0 ? 'is-up' : 'is-down';

  return (
    <li className="perpetual-position-card">
      <div className="perpetual-position-card__head">
        <span className={`perpetual-position-card__badge ${isLong ? 'is-up' : 'is-down'}`}>
          {isLong ? '做多' : '做空'}
        </span>
        <strong>{pairLabel}</strong>
        <span className="perpetual-position-card__leverage">
          全倉 X{order.contractMultiple} (USDT)
        </span>
      </div>

      <div className="perpetual-position-card__grid">
        <div>
          <span>鎖倉期限</span>
          <strong>{formatStakingLabel(playConfig.stakingTimeDays)}</strong>
        </div>
        <div>
          <span>下單金額</span>
          <strong>{formatPrice(order.betAmount, 6)}</strong>
        </div>
        <div>
          <span>保證金</span>
          <strong>{formatPrice(order.margin, 6)}</strong>
        </div>
        <div>
          <span>保證金餘額</span>
          <strong>{formatPrice(balance, 4)}</strong>
        </div>
        <div>
          <span>開倉價</span>
          <strong>{formatPrice(order.orderPrice, 4)}</strong>
        </div>
        <div>
          <span>最新價格</span>
          <strong>{formatPrice(currentPrice, 4)}</strong>
        </div>
        <div>
          <span>強平價格</span>
          <strong>{formatPrice(order.liquidationPrice, 4)}</strong>
        </div>
        <div>
          <span>止盈</span>
          <strong>{order.takeProfitPrice ? formatPrice(order.takeProfitPrice, 4) : '—'}</strong>
        </div>
        <div>
          <span>止損</span>
          <strong>{order.stopLossPrice ? formatPrice(order.stopLossPrice, 4) : '—'}</strong>
        </div>
      </div>

      <div className="perpetual-position-card__pnl">
        <div>
          <span>未實現盈虧</span>
          <strong className={pnlClass}>{formatPrice(unrealizedPnl, 6)}</strong>
        </div>
        <div>
          <span>收益率</span>
          <strong className={pnlClass}>{formatPrice(roi, 6)}%</strong>
        </div>
        <div>
          <span>手續費</span>
          <strong>{formatPrice(order.fee, 6)}</strong>
        </div>
      </div>

      <div className="perpetual-position-card__footer">
        <span>{order.createTime || '—'}</span>
        <div className="perpetual-position-card__actions">
          <button type="button" onClick={() => onEditTpSl?.(order)}>
            止盈止損
          </button>
          <button
            type="button"
            disabled={closing}
            onClick={() => onClosePosition?.(order)}
          >
            {closing ? '平倉中…' : '平倉'}
          </button>
        </div>
      </div>
    </li>
  );
}
